import styled from 'styled-components';

export const StyledStrong = styled.strong`
  font-weight: ${({ weight }) => weight};
  font-size: ${({ fontSize }) => fontSize};
`;
